import { HeaderNavigation } from './types';

/**
 * Base class of the handlers for the navigation of the header.
 */
export class Navigation implements HeaderNavigation {
  headerEl: HTMLElement;
  navigationEl: HTMLElement;
  links?: NodeListOf<HTMLLinkElement> | undefined;

  /**
   * Create a new navigation handler.
   * @param navigationEl  The <nav/> element the handler will be attached to.
   */
  constructor(headerEl: HTMLElement, navigationEl: HTMLElement) {
    this.headerEl = headerEl;
    this.navigationEl = navigationEl;
  }

  /**
   *
   * @protected
   */
  protected addEventListeners() {}

  /**
   *
   * @protected
   */
  protected removeEventListeners() {}

  /**
   *
   * @param item
   */
  openSubnavigation(item: HTMLElement) {}

  /**
   *
   * @param subnavigation
   */
  closeSubnavigation(subnavigation: HTMLDivElement) {}

  /**
   *
   */
  onNavigationClose() {}

  /**
   * Destroy the navigation handler, which will allow us to do some cleanup.
   */
  destroy() {
    this.removeEventListeners();
  }

  /**
   *
   * @param e
   */
  handleNavigationLinkClick(e: MouseEvent) {}

  /**
   *
   * @param e
   */
  handleBackButtonClick(e: MouseEvent) {}
}
